import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './animated-routes.scss';

const propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  animationStyle: PropTypes.string,
};

export const absolute = (Component, zIndex) => (props) => (
  <div
    className={styles.container}
    style={{ zIndex }}
  >
    <Component {...props} />
  </div>
);

absolute.propTypes = {
  zIndex: PropTypes.number,
};

const slideIn = {
  appear: styles.siAppear,
  appearActive: styles.siActiveAppear,
  enter: styles.siEnter,
  enterActive: styles.siEnterActive,
  enterDone: styles.siEnterDone,
  exit: styles.siExit,
  exitActive: styles.siExitActive,
  exitDone: styles.siExitDone,
};

const slideUp = {
  appear: styles.suAppear,
  appearActive: styles.suActiveAppear,
  enter: styles.suEnter,
  enterActive: styles.suEnterActive,
  enterDone: styles.suEnterDone,
  exit: styles.suExit,
  exitActive: styles.suExitActive,
  exitDone: styles.suExitDone,
};

const blurIn = {
  appear: styles.biAppear,
  appearActive: styles.biActiveAppear,
  enter: styles.biEnter,
  enterActive: styles.biEnterActive,
  enterDone: styles.biEnterDone,
  exit: styles.biExit,
  exitActive: styles.biExitActive,
  exitDone: styles.biExitDone,
};

const animationKeys = {
  slideIn,
  slideUp,
  blurIn,
};

const AnimatedRoutes = ({
  match,
  location,
  children,
  animationStyle = 'slideIn',
}) => {
  const animationClassNames = animationKeys[animationStyle];
  const key = (match && match.path) || location.pathname;
  return (
    <TransitionGroup>
      <CSSTransition
        key={key}
        timeout={500}
        classNames={animationClassNames}
      >
        <Switch location={location}>
          {children}
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

AnimatedRoutes.propTypes = propTypes;
export default AnimatedRoutes;
